import styled from "styled-components";
import Fonts from "../../themes/Fonts";
import Colors from "../../themes/Colors";
import { fadeIn } from "../Common/CommonStyles";

//Input
export const Input = styled.input.attrs((props) => ({
  ...(props.type === "date" && {
    min: props.minDate || undefined,
    max: props.maxDate || undefined,
    lang: "es",
  }),
  'data-testid': props.testid
}))`
  padding: 10px;
  font-size: ${({ fontSize }) => fontSize || "16px"};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  border-radius: ${({ borderRadius }) => borderRadius || "4px"};
  border: 1px solid #ccc;
  outline: none;
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "15px"};
  maxlength: ${(props) => props.maxLength || undefined};

  /* Estilos adicionales según el estado del componente */
  &:focus {
    border-color: blue;
    box-shadow: 0 0 5px rgba(0, 0, 255, 0.3);
  }

  &::placeholder {
    color: #aaa;
  }

  /* Estilos responsive */
  @media (max-width: 844px) {
    font-size: ${({ responsiveFontSize }) => responsiveFontSize || "15px"};
    padding: ${({ responsivePadding }) => responsivePadding || "2px"};
    width: ${(props) => props.width || "350px"};
    height: 35px;
    animation: ${fadeIn} 0.5s ease-in;
  }

  @media (max-width: 320px) {
    width: 200px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const SuggestionsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  background-color: white;
  li {
    padding: 5px;
    cursor: pointer;

    &:hover {
      background-color: ${(props) =>
        props.hoverBgColor || Colors.primaryPrimera};
      color: white;
    }
  }
`;

//InputIcon
export const IconInputContainer = styled.div`
  flex: 1;
  position: ${({ position }) => position || "relative"};
  @media screen and (max-width: 844px) {
    position: relative;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const ErrorMessage = styled.div`
  color: ${Colors.huMyHealth};
  font-size: 14px;
  margin-top: 5px;
`;

//Select
export const Select = styled.select.attrs(props => ({
  'data-testid': props.testid
}))`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  width: ${(props) => props.width || ""};
  height: ${(props) => props.height || "37px"};
  @media (max-width: 844px) {
    font-size: ${({ responsiveFontSize }) => responsiveFontSize || "18px"};
    padding: ${({ responsivePadding }) => responsivePadding || "2px"};
    width: ${(props) => props.width || "350px"};
    height: 45px;
    animation: ${fadeIn} 0.5s ease-in;
  }
  @media (max-width: 320px) {
    width: 200px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const SelectContainer = styled.div`
  display: inline-block;
  position: relative;
`;

export const SelectField = styled.select`
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  appearance: none;
  cursor: pointer;
  width: ${(props) => props.width || "200px"};
  height: ${(props) => props.height || "47px"};
`;

export const SelectArrow = styled.div`
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  border-color: #666 transparent transparent transparent;
  pointer-events: none;
`;

//Form
export const FormWrapper = styled.div`
  border: ${(props) =>
    props?.borderColor
      ? "3px solid " + props?.borderColor
      : "3px solid " + Colors.primaryPrimera};
  padding: 20px;
  border-radius: 12px;
  flex: ${({ flex }) => flex || "1"};
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  flex-direction: ${({ flexDirection }) => flexDirection || "column"};
  display: ${({ display }) => display || "flex"};
  box-sizing: border-box;
  @media screen and (max-width: 844px) {
    flex-wrap: wrap;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const Form = styled.form`
  display: flex;
  margin-bottom: ${({ margin }) => margin || ""};
  margin-top: ${({ marginTop }) => marginTop || ""};
  margin-bottom: ${({ marginBottom }) => marginBottom || ""};
  flex-wrap: wrap;
  justify-content: ${({ justifyContent }) => justifyContent || "space-evenly"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  align-items: ${({ alignItems }) => alignItems || "flex-start"};
  flex-direction: ${(props) => props.flexDirection || "column"};
  justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
  width: ${(props) => props.width || "calc(33.33% - 10px)"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "20px"};
  @media screen and (max-width: 844px) {
    width: calc(33.33% - 20px);
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent || "space-between"};
  align-items: ${({ alignItems }) => alignItems || "flex-start"};
  width: 100%;
  gap: 20px;
  margin-bottom: 20px;
  @media screen and (max-width: 844px) {
    flex-direction: column;
    gap: 10px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

//Label
export const Label = styled.label`
  margin-bottom: 5px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  color: ${(props) => props.color || "black"};
  font-weight: ${(props) => props.weight || "normal"};
  @media (max-width: 844px) {
    font-size: ${({ responsiveFontSize }) => responsiveFontSize || "18px"};
    padding: ${({ responsivePadding }) => responsivePadding || "2px"};
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const LabelWithContainer = styled.label`
  margin-bottom: 5px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  display: ${(props) => props.labelJustify || "flex"};
  width: ${(props) => props.labelWidth || "250px"};
  height: ${(props) => props.labelHeight || "50px"};
  background-color: ${(props) => props.labelBgColor || Colors.blueTransparent};
  color: ${(props) => props.labelTextColor || Colors.primaryPrimera};
  justify-content: ${(props) => props.labelJustify || "center"};
  line-height: ${(props) => props.labelLineHeigth || "50px"};
  font-weight: ${(props) => props.labelWeight || "bold"};
`;

// Checkbox
export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 22px;
  height: 22px;
  background: ${(props) =>
    props.checked
      ? props.checkedColor || Colors.primaryPrimera
      : props.uncheckedColor || Colors.white};
  border: 1px solid ${(props) =>
    props.checked
      ? props.checkedColor || Colors.primaryPrimera
      : Colors.grey};
  border-radius: 3px;
  transition: all 150ms;
  cursor: pointer;
  pointer-events: none;
`;

export const CheckmarkIcon = styled.svg`
  fill: none;
  stroke: ${(props) => props.checkmarkColor || Colors.white};
  stroke-width: 2px;
`;

export const CheckboxLabelContainer = styled.label`
  display: flex;
  padding: ${(props) => (props.padding ? props.padding : "")};
  gap: 8px;
  cursor: pointer;

  span {
    font-size: 16px;
    color: #333;
  }
`;

export const TextboxContainer = styled.div`
  width: ${(props) => props.width || "100%"};
  margin-bottom: ${(props) => props.marginBottom || "15px"};
`;

export const TextboxLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: ${(props) => props.labelSize || "14px"};
  font-weight: ${(props) => props.labelWeight || "500"};
  color: ${(props) => props.labelColor || Colors.txt};
  font-family: ${Fonts.familyVerlag};
`;

export const Textbox = styled.textarea`
  width: 100%;
  min-height: ${(props) => props.minHeight || "100px"};
  max-height: ${(props) => props.maxHeight || "200px"};
  padding: ${(props) => props.padding || "10px"};
  font-size: ${(props) => props.fontSize || "14px"};
  font-family: ${Fonts.familyVerlag};
  border: 1px solid ${(props) => (props.hasError ? Colors.error : Colors.grey)};
  border-radius: 4px;
  background-color: ${Colors.white};
  color: ${Colors.txt};
  resize: vertical;
  outline: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    border-color: ${(props) =>
      props.hasError ? Colors.error : Colors.primaryHumano};
    box-shadow: ${(props) =>
      props.hasError
        ? `0 0 0 0.2rem ${Colors.error}40`
        : `0 0 0 0.2rem ${Colors.primaryHumano}40`};
  }

  &:hover {
    border-color: ${(props) => {
      if (props.disabled) return Colors.grey;
      if (props.hasError) return Colors.error;
      return Colors.primaryHumano;
    }};
  }

  &::placeholder {
    color: ${Colors.grayFont};
    font-style: italic;
  }

  &:disabled {
    background-color: ${Colors.greyLight};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const TextboxErrorMessage = styled.div`
  color: ${Colors.error};
  font-size: 12px;
  margin-top: 4px;
  font-family: ${Fonts.familyVerlag};
`;

export const TextboxHelpText = styled.div`
  color: ${Colors.grayFont};
  font-size: 12px;
  margin-top: 4px;
  font-family: ${Fonts.familyVerlag};
`;
